import { render } from "./ProductModalComponent.vue?vue&type=template&id=8fe4d81e"
import script from "./ProductModalComponent.vue?vue&type=script&lang=js"
export * from "./ProductModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/product/ProductModalComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fe4d81e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fe4d81e', __exports__)) {
    api.reload('8fe4d81e', __exports__)
  }
  
  module.hot.accept("./ProductModalComponent.vue?vue&type=template&id=8fe4d81e", () => {
    api.rerender('8fe4d81e', render)
  })

}


export default __exports__